<template>
    <div class="fivefu">
        <Head :index="'5'"></Head>
        <!-- <div class="chartTop"> -->
            <!-- <div class="fl">
                山东省莒县阎庄镇孙家山沟村孙其昌后裔族谱|孙其昌 <span> 共563人</span>
            </div> -->
        <!-- </div> -->
        <div class="flSearch">
            本人名： <el-input type="text" v-model="name" autocomplete="off" placeholder="本人姓名"></el-input>
           &nbsp;&nbsp;父亲名：<el-input type="text" v-model="fathername" autocomplete="off" placeholder="父亲姓名"></el-input>
           &nbsp; <el-button @click="search()" type="primary" size="small" style="padding: 12px;" >查看</el-button><!--  style="margin-left:107px" -->
        </div><!-- size="small" -->
       <el-tabs v-model="activeName" @tab-click="handleClick" style="padding:0 10px">
        <el-tab-pane label="九族五服表" name="table">
            <table class="el-table fiveTable" style="width:100%;max-height:100%;" border="1" align="left" >
                <thead class="has-gutter">
                    <tr class="">
                        <th class="is-center is-leaf el-table__cell" style="width:110px"><div class="cell">血缘关系</div></th>
                        <th class="is-center is-leaf el-table__cell" style="width:180px"><div class="cell">称谓</div></th>
                        <th class="is-center is-leaf el-table__cell" style="width:110px"><div class="cell">姓名</div></th>
                        <th class="is-center is-leaf el-table__cell" style="width:110px" ><div class="cell">在世情况</div></th>
                    </tr>
                </thead>
                <tbody>
                <tr v-if="tableData.length == 0">
                    <td colspan="5" style="text-align:center">暂无数据</td>
                </tr>
                <tr class="el-table__row backColor1" v-for="(item, index) in data.oneFuZiJi" :key="index">
                    <td v-if="index == 0" :rowspan="data.oneFuZiJi.length">
                        <div class="cell">一服</div>
                    </td>
                    <td v-if="index == 0" :rowspan="data.oneFuZiJi.length">
                        <div class="cell">自己</div>
                    </td>
                    <td>
                        <div class="cell">{{ item.xm }}</div>
                    </td>
                    <td style="text-align:center">
                        <div class="cell">{{ item.sgzt == 1 ? "已故":"在世" }}</div>
                    </td>
                </tr>
                <tr class="el-table__row backColor1" v-for="(item1, index1) in data.oneFuFuMu" :key="index1">
                    <td v-if="index1 == 0" :rowspan="data.oneFuFuMu.length">
                        <div class="cell">一服</div>
                    </td>
                    <td v-if="index1 == 0" :rowspan="data.oneFuFuMu.length">
                        <div class="cell">父母</div>
                    </td>
                    <td>
                        <div class="cell">{{ item1.xm }}</div>
                    </td>
                    <td style="text-align:center">
                        <div class="cell">{{ item1.sgzt == 1 ? "已故":"在世" }}</div>
                    </td>
                </tr>
                <tr class="el-table__row backColor1" v-for="(item2, index2) in data.oneFuZiNv" :key="index2">
                    <td v-if="index2 == 0" :rowspan="data.oneFuZiNv.length">
                        <div class="cell">一服</div>
                    </td>
                    <td v-if="index2 == 0" :rowspan="data.oneFuZiNv.length">
                        <div class="cell">子女</div>
                    </td>
                    <td>
                        <div class="cell">{{ item2.xm }}</div>
                    </td>
                    <td style="text-align:center">
                        <div class="cell">{{ item2.sgzt == 1 ? "已故":"在世" }}</div>
                    </td>
                </tr>
                <tr class="el-table__row backColor2" v-for="(item3, index3) in data.twoFuZuFuMu" :key="index3">
                    <td v-if="index3 == 0" :rowspan="data.twoFuZuFuMu.length">
                        <div class="cell">二服</div>
                    </td>
                    <td v-if="index3 == 0" :rowspan="data.twoFuZuFuMu.length">
                        <div class="cell">祖父母</div>
                    </td>
                    <td>
                        <div class="cell">{{ item3.xm }}</div>
                    </td>
                    <td style="text-align:center">
                        <div class="cell">{{ item3.sgzt == 1 ? "已故":"在世"  }}</div>
                    </td>
                </tr>
                <tr class="el-table__row backColor2" v-for="(item4, index4) in data.twoFuXiongDi" :key="index4">
                    <td v-if="index4 == 0" :rowspan="data.twoFuXiongDi.length">
                        <div class="cell">二服</div>
                    </td>
                    <td v-if="index4 == 0" :rowspan="data.twoFuXiongDi.length">
                        <div class="cell">兄弟</div>
                    </td>
                    <td>
                        <div class="cell">{{ item4.xm }}</div>
                    </td>
                    <td style="text-align:center">
                        <div class="cell">{{ item4.sgzt == 1 ? "已故":"在世"  }}</div>
                    </td>
                </tr>
                <tr class="el-table__row backColor2" v-for="(item5, index5) in data.twoFuJieMei" :key="index5">
                    <td v-if="index5 == 0" :rowspan="data.twoFuJieMei.length">
                        <div class="cell">二服</div>
                    </td>
                    <td v-if="index5 == 0" :rowspan="data.twoFuJieMei.length">
                        <div class="cell">姐妹</div>
                    </td>
                    <td>
                        <div class="cell">{{ item5.xm }}</div>
                    </td>
                    <td style="text-align:center">
                        <div class="cell">{{ item5.sgzt == 1 ? "已故":"在世"  }}</div>
                    </td>
                </tr>
                <tr class="el-table__row backColor2" v-for="(item6, index6) in data.twoFuShuBo" :key="index6">
                    <td v-if="index6 == 0" :rowspan="data.twoFuShuBo.length">
                        <div class="cell">二服</div>
                    </td>
                    <td v-if="index6 == 0" :rowspan="data.twoFuShuBo.length">
                        <div class="cell">叔伯</div>
                    </td>
                    <td>
                        <div class="cell">{{ item6.xm }}</div>
                    </td>
                    <td style="text-align:center">
                        <div class="cell">{{ item6.sgzt == 1 ? "已故":"在世"  }}</div>
                    </td>
                </tr>
                <tr class="el-table__row backColor2" v-for="(item7, index7) in data.twoFuGuGu" :key="index7">
                    <td v-if="index7 == 0" :rowspan="data.twoFuGuGu.length">
                        <div class="cell">二服</div>
                    </td>
                    <td v-if="index7 == 0" :rowspan="data.twoFuGuGu.length">
                        <div class="cell">姑姑</div>
                    </td>
                    <td>
                        <div class="cell">{{ item7.xm }}</div>
                    </td>
                    <td style="text-align:center">
                        <div class="cell">{{ item7.sgzt == 1 ? "已故":"在世"  }}</div>
                    </td>
                </tr>
                <tr class="el-table__row backColor2" v-for="(item8, index8) in data.twoFuZhiZi" :key="index8">
                    <td v-if="index8 == 0" :rowspan="data.twoFuZhiZi.length">
                        <div class="cell">二服</div>
                    </td>
                    <td v-if="index8 == 0" :rowspan="data.twoFuZhiZi.length">
                        <div class="cell">侄子</div>
                    </td>
                    <td>
                        <div class="cell">{{ item8.xm }}</div>
                    </td>
                    <td style="text-align:center">
                        <div class="cell">{{ item8.sgzt == 1 ? "已故":"在世"  }}</div>
                    </td>
                </tr>
                <tr class="el-table__row backColor2" v-for="(item9, index9) in data.twoFuZhiNv" :key="index9">
                    <td v-if="index9 == 0" :rowspan="data.twoFuZhiNv.length">
                        <div class="cell">二服</div>
                    </td>
                    <td v-if="index9 == 0" :rowspan="data.twoFuZhiNv.length">
                        <div class="cell">侄女</div>
                    </td>
                    <td>
                        <div class="cell">{{ item9.xm }}</div>
                    </td>
                    <td style="text-align:center">
                        <div class="cell">{{ item9.sgzt == 1 ? "已故":"在世"  }}</div>
                    </td>
                </tr>
                <tr class="el-table__row backColor2" v-for="(item10, index10) in data.twoFuSunZiNv" :key="index10">
                    <td v-if="index10 == 0" :rowspan="data.twoFuSunZiNv.length">
                        <div class="cell">二服</div>
                    </td>
                    <td v-if="index10 == 0" :rowspan="data.twoFuSunZiNv.length">
                        <div class="cell">孙子孙女</div>
                    </td>
                    <td>
                        <div class="cell">{{ item10.xm }}</div>
                    </td>
                    <td style="text-align:center">
                        <div class="cell">{{ item10.sgzt == 1 ? "已故":"在世"  }}</div>
                    </td>
                </tr>
                <tr class="el-table__row backColor3" v-for="(item11, index11) in data.threeFuZengZuMu" :key="index11">
                    <td v-if="index11 == 0" :rowspan="data.threeFuZengZuMu.length">
                        <div class="cell">三服</div>
                    </td>
                    <td v-if="index11 == 0" :rowspan="data.threeFuZengZuMu.length">
                        <div class="cell">曾祖、祖母</div>
                    </td>
                    <td>
                        <div class="cell">{{ item11.xm }}</div>
                    </td>
                    <td style="text-align:center">
                        <div class="cell">{{ item11.sgzt == 1 ? "已故":"在世"  }}</div>
                    </td>
                </tr>
                <tr class="el-table__row backColor3" v-for="(item12, index12) in data.threeFuZengSunNv" :key="index12">
                    <td v-if="index12 == 0" :rowspan="data.threeFuZengSunNv.length">
                        <div class="cell">三服</div>
                    </td>
                    <td v-if="index12 == 0" :rowspan="data.threeFuZengSunNv.length">
                        <div class="cell">曾孙、孙女</div>
                    </td>
                    <td>
                        <div class="cell">{{ item12.xm }}</div>
                    </td>
                    <td>
                        <div class="cell">{{ item12.sgzt == 1 ? "已故":"在世"  }}</div>
                    </td>
                </tr>
                <tr class="el-table__row backColor3" v-for="(item13, index13) in data.threeFuShuBoZuFuMu" :key="index13">
                    <td v-if="index13 == 0" :rowspan="data.threeFuShuBoZuFuMu.length">
                        <div class="cell">三服</div>
                    </td>
                    <td v-if="index13 == 0" :rowspan="data.threeFuShuBoZuFuMu.length">
                        <div class="cell">叔伯祖父、叔伯祖母</div>
                    </td>
                    <td>
                        <div class="cell">{{ item13.xm }}</div>
                    </td>
                    <td style="text-align:center">
                        <div class="cell">{{ item13.sgzt == 1 ? "已故":"在世"  }}</div>
                    </td>
                </tr>
                <tr class="el-table__row backColor3" v-for="(item14, index14) in data.threeFuZuGu" :key="index14">
                    <td v-if="index14 == 0" :rowspan="data.threeFuZuGu.length">
                        <div class="cell">三服</div>
                    </td>
                    <td v-if="index14 == 0" :rowspan="data.threeFuZuGu.length">
                        <div class="cell">祖姑</div>
                    </td>
                    <td>
                        <div class="cell">{{ item14.xm }}</div>
                    </td>
                    <td style="text-align:center">
                        <div class="cell">{{ item14.sgzt == 1 ? "已故":"在世"  }}</div>
                    </td>
                </tr>
                <tr class="el-table__row backColor3" v-for="(item15, index15) in data.threeFuShuBoSun" :key="index15">
                    <td v-if="index15 == 0" :rowspan="data.threeFuShuBoSun.length">
                        <div class="cell">三服</div>
                    </td>
                    <td v-if="index15 == 0" :rowspan="data.threeFuShuBoSun.length">
                        <div class="cell">叔伯孙子</div>
                    </td>
                    <td>
                        <div class="cell">{{ item15.xm }}</div>
                    </td>
                    <td style="text-align:center">
                        <div class="cell">{{ item15.sgzt == 1 ? "已故":"在世"  }}</div>
                    </td>
                </tr>
                <tr class="el-table__row backColor3" v-for="(item16, index16) in data.threeFuShuBoSunNv" :key="index16">
                    <td v-if="index16 == 0" :rowspan="data.threeFuShuBoSunNv.length">
                        <div class="cell">三服</div>
                    </td>
                    <td v-if="index16 == 0" :rowspan="data.threeFuShuBoSunNv.length">
                        <div class="cell">叔伯孙女</div>
                    </td>
                    <td>
                        <div class="cell">{{ item16.xm }}</div>
                    </td>
                    <td style="text-align:center">
                        <div class="cell">{{ item16.sgzt == 1 ? "已故":"在世"  }}</div>
                    </td>
                </tr>
                <tr class="el-table__row backColor3" v-for="(item17, index17) in data.threeFuShuBoFuMu" :key="index17">
                    <td v-if="index17 == 0" :rowspan="data.threeFuShuBoFuMu.length">
                        <div class="cell">三服</div>
                    </td>
                    <td v-if="index17 == 0" :rowspan="data.threeFuShuBoFuMu.length">
                        <div class="cell">叔伯父母</div>
                    </td>
                    <td>
                        <div class="cell">{{ item17.xm }}</div>
                    </td>
                    <td style="text-align:center">
                        <div class="cell">{{ item17.sgzt == 1 ? "已故":"在世"  }}</div>
                    </td>
                </tr>
                <tr class="el-table__row backColor3" v-for="(item18, index18) in data.threeFuShuBoGu" :key="index18">
                    <td v-if="index18 == 0" :rowspan="data.threeFuShuBoGu.length">
                        <div class="cell">三服</div>
                    </td>
                    <td v-if="index18 == 0" :rowspan="data.threeFuShuBoGu.length">
                        <div class="cell">叔伯姑姑</div>
                    </td>
                    <td>
                        <div class="cell">{{ item18.xm }}</div>
                    </td>
                    <td style="text-align:center">
                        <div class="cell">{{ item18.sgzt == 1 ? "已故":"在世"  }}</div>
                    </td>
                </tr>
                <tr class="el-table__row backColor3" v-for="(item19, index19) in data.threeFuShuBoZhiZi" :key="index19">
                    <td v-if="index19 == 0" :rowspan="data.threeFuShuBoZhiZi.length">
                        <div class="cell">三服</div>
                    </td>
                    <td v-if="index19 == 0" :rowspan="data.threeFuShuBoZhiZi.length">
                        <div class="cell">叔伯侄子</div>
                    </td>
                    <td>
                        <div class="cell">{{ item19.xm }}</div>
                    </td>
                    <td style="text-align:center">
                        <div class="cell">{{ item19.sgzt == 1 ? "已故":"在世"  }}</div>
                    </td>
                </tr>
                <tr class="el-table__row backColor3" v-for="(item20, index20) in data.threeFuShuBoZhiNv" :key="index20">
                    <td v-if="index20 == 0" :rowspan="data.threeFuShuBoZhiNv.length">
                        <div class="cell">三服</div>
                    </td>
                    <td v-if="index20 == 0" :rowspan="data.threeFuShuBoZhiNv.length">
                        <div class="cell">叔伯侄女</div>
                    </td>
                    <td>
                        <div class="cell">{{ item20.xm }}</div>
                    </td>
                    <td style="text-align:center">
                        <div class="cell">{{ item20.sgzt == 1 ? "已故":"在世"  }}</div>
                    </td>
                </tr>
                <tr class="el-table__row backColor3" v-for="(item21, index21) in data.threeFuShuBoXiongDi" :key="index21">
                    <td v-if="index21 == 0" :rowspan="data.threeFuShuBoXiongDi.length">
                        <div class="cell">三服</div>
                    </td>
                    <td v-if="index21 == 0" :rowspan="data.threeFuShuBoXiongDi.length">
                        <div class="cell">叔伯兄弟</div>
                    </td>
                    <td>
                        <div class="cell">{{ item21.xm }}</div>
                    </td>
                    <td style="text-align:center">
                        <div class="cell">{{ item21.sgzt == 1 ? "已故":"在世"  }}</div>
                    </td>
                </tr>
                <tr class="el-table__row backColor3" v-for="(item22, index22) in data.threeFuShuBoJieMei" :key="index22">
                    <td v-if="index22 == 0" :rowspan="data.threeFuShuBoJieMei.length">
                        <div class="cell">三服</div>
                    </td>
                    <td v-if="index22 == 0" :rowspan="data.threeFuShuBoJieMei.length">
                        <div class="cell">叔伯姐妹</div>
                    </td>
                    <td>
                        <div class="cell">{{ item22.xm }}</div>
                    </td>
                    <td style="text-align:center">
                        <div class="cell">{{ item22.sgzt == 1 ? "已故":"在世"  }}</div>
                    </td>
                </tr>
                <tr class="el-table__row backColor3" v-for="(item23, index23) in data.threeFuShuBoBoFuMu" :key="index23">
                    <td v-if="index23 == 0" :rowspan="data.threeFuShuBoBoFuMu.length">
                        <div class="cell">三服</div>
                    </td>
                    <td v-if="index23 == 0" :rowspan="data.threeFuShuBoBoFuMu.length">
                        <div class="cell">叔伯伯</div>
                    </td>
                    <td>
                        <div class="cell">{{ item23.xm }}</div>
                    </td>
                    <td style="text-align:center">
                        <div class="cell">{{ item23.sgzt == 1 ? "已故":"在世"  }}</div>
                    </td>
                </tr>
                <tr class="el-table__row backColor4" v-for="(item24, index24) in data.fourFuTangZuFuMu" :key="index24">
                    <td v-if="index24 == 0" :rowspan="data.fourFuTangZuFuMu.length">
                        <div class="cell">四服</div>
                    </td>
                    <td v-if="index24 == 0" :rowspan="data.fourFuTangZuFuMu.length">
                        <div class="cell">堂祖父母</div>
                    </td>
                    <td>
                        <div class="cell">{{ item24.xm }}</div>
                    </td>
                    <td style="text-align:center">
                        <div class="cell">{{ item24.sgzt == 1 ? "已故":"在世"  }}</div>
                    </td>
                </tr>
                <tr class="el-table__row backColor4" v-for="(item25, index25) in data.fourFuTangZuGu" :key="index25">
                    <td v-if="index25 == 0" :rowspan="data.fourFuTangZuGu.length">
                        <div class="cell">四服</div>
                    </td>
                    <td v-if="index25 == 0" :rowspan="data.fourFuTangZuGu.length">
                        <div class="cell">堂祖姑</div>
                    </td>
                    <td>
                        <div class="cell">{{ item25.xm }}</div>
                    </td>
                    <td style="text-align:center">
                        <div class="cell">{{ item25.sgzt == 1 ? "已故":"在世"  }}</div>
                    </td>
                </tr>
                <tr class="el-table__row backColor4" v-for="(item26, index26) in data.fourFuTangSunZi" :key="index26">
                    <td v-if="index26 == 0" :rowspan="data.fourFuTangSunZi.length">
                        <div class="cell">四服</div>
                    </td>
                    <td v-if="index26 == 0" :rowspan="data.fourFuTangSunZi.length">
                        <div class="cell">堂孙子</div>
                    </td>
                    <td>
                        <div class="cell">{{ item26.xm }}</div>
                    </td>
                    <td style="text-align:center">
                        <div class="cell">{{ item26.sgzt == 1 ? "已故":"在世"  }}</div>
                    </td>
                </tr>
                <tr class="el-table__row backColor4" v-for="(item27, index27) in data.fourFuTangSunNv" :key="index27">
                    <td v-if="index27 == 0" :rowspan="data.fourFuTangSunNv.length">
                        <div class="cell">四服</div>
                    </td>
                    <td v-if="index27 == 0" :rowspan="data.fourFuTangSunNv.length">
                        <div class="cell">堂孙女</div>
                    </td>
                    <td>
                        <div class="cell">{{ item27.xm }}</div>
                    </td>
                    <td style="text-align:center">
                        <div class="cell">{{ item27.sgzt == 1 ? "已故":"在世"  }}</div>
                    </td>
                </tr>
                <tr class="el-table__row backColor4" v-for="(item28, index28) in data.fourFuGaoZuFuMu" :key="index28">
                    <td v-if="index28 == 0" :rowspan="data.fourFuGaoZuFuMu.length">
                        <div class="cell">四服</div>
                    </td>
                    <td v-if="index28 == 0" :rowspan="data.fourFuGaoZuFuMu.length">
                        <div class="cell">高祖父母</div>
                    </td>
                    <td>
                        <div class="cell">{{ item28.xm }}</div>
                    </td>
                    <td style="text-align:center">
                        <div class="cell">{{ item28.sgzt == 1 ? "已故":"在世"  }}</div>
                    </td>
                </tr>
                <tr class="el-table__row backColor4" v-for="(item29, index29) in data.fourFuXuanSunNv" :key="index29">
                    <td v-if="index29 == 0" :rowspan="data.fourFuXuanSunNv.length">
                        <div class="cell">四服</div>
                    </td>
                    <td v-if="index29 == 0" :rowspan="data.fourFuXuanSunNv.length">
                        <div class="cell">玄孙玄孙女</div>
                    </td>
                    <td>
                        <div class="cell">{{ item29.xm }}</div>
                    </td>
                    <td style="text-align:center">
                        <div class="cell">{{ item29.sgzt == 1 ? "已故":"在世"  }}</div>
                    </td>
                </tr>
                <tr class="el-table__row backColor4" v-for="(item30, index30) in data.fourFuShuBoZengZuFuMu" :key="index30">
                    <td v-if="index30 == 0" :rowspan="data.fourFuShuBoZengZuFuMu.length">
                        <div class="cell">四服</div>
                    </td>
                    <td v-if="index30 == 0" :rowspan="data.fourFuShuBoZengZuFuMu.length">
                        <div class="cell">叔伯曾祖父母</div>
                    </td>
                    <td>
                        <div class="cell">{{ item30.xm }}</div>
                    </td>
                    <td style="text-align:center">
                        <div class="cell">{{ item30.sgzt == 1 ? "已故":"在世"  }}</div>
                    </td>
                </tr>
                <tr class="el-table__row backColor4" v-for="(item31, index31) in data.fourFuZengZuGu" :key="index31">
                    <td v-if="index31 == 0" :rowspan="data.fourFuZengZuGu.length">
                        <div class="cell">四服</div>
                    </td>
                    <td v-if="index31 == 0" :rowspan="data.fourFuZengZuGu.length">
                        <div class="cell">曾祖姑</div>
                    </td>
                    <td>
                        <div class="cell">{{ item31.xm }}</div>
                    </td>
                    <td style="text-align:center">
                        <div class="cell">{{ item31.sgzt == 1 ? "已故":"在世"  }}</div>
                    </td>
                </tr>
                <tr class="el-table__row backColor4" v-for="(item32, index32) in data.fourFuShuBoZengSun" :key="index32">
                    <td v-if="index32 == 0" :rowspan="data.fourFuShuBoZengSun.length">
                        <div class="cell">四服</div>
                    </td>
                    <td v-if="index32 == 0" :rowspan="data.fourFuShuBoZengSun.length">
                        <div class="cell">叔伯曾孙</div>
                    </td>
                    <td>
                        <div class="cell">{{ item32.xm }}</div>
                    </td>
                    <td>
                        <div class="cell">{{ item32.sgzt == 1 ? "已故":"在世"  }}</div>
                    </td>
                </tr>
                <tr class="el-table__row backColor4" v-for="(item33, index33) in data.fourFuBoShuZengSunNv" :key="index33">
                    <td v-if="index33 == 0" :rowspan="data.fourFuBoShuZengSunNv.length">
                        <div class="cell">四服</div>
                    </td>
                    <td v-if="index33 == 0" :rowspan="data.fourFuBoShuZengSunNv.length">
                        <div class="cell">叔伯曾孙女</div>
                    </td>
                    <td>
                        <div class="cell">{{ item33.xm }}</div>
                    </td>
                    <td style="text-align:center">
                        <div class="cell">{{ item33.sgzt == 1 ? "已故":"在世"  }}</div>
                    </td>
                </tr>
                <tr class="el-table__row backColor4" v-for="(item34, index34) in data.fourFuTangBoFuMu" :key="index34">
                    <td v-if="index34 == 0" :rowspan="data.fourFuTangBoFuMu.length">
                        <div class="cell">四服</div>
                    </td>
                    <td v-if="index34 == 0" :rowspan="data.fourFuTangBoFuMu.length">
                        <div class="cell">堂伯父母</div>
                    </td>
                    <td>
                        <div class="cell">{{ item34.xm }}</div>
                    </td>
                    <td style="text-align:center">
                        <div class="cell">{{ item34.sgzt == 1 ? "已故":"在世"  }}</div>
                    </td>
                </tr>
                <tr class="el-table__row backColor4" v-for="(item35, index35) in data.fourFuTangGu" :key="index35">
                    <td v-if="index35 == 0" :rowspan="data.fourFuTangGu.length">
                        <div class="cell">四服</div>
                    </td>
                    <td v-if="index35 == 0" :rowspan="data.fourFuTangGu.length">
                        <div class="cell">堂姑</div>
                    </td>
                    <td>
                        <div class="cell">{{ item35.xm }}</div>
                    </td>
                    <td style="text-align:center">
                        <div class="cell">{{ item35.sgzt == 1 ? "已故":"在世"  }}</div>
                    </td>
                </tr>
                <tr class="el-table__row backColor4" v-for="(item36, index36) in data.fourFuTangZhi" :key="index36">
                    <td v-if="index36 == 0" :rowspan="data.fourFuTangZhi.length">
                        <div class="cell">四服</div>
                    </td>
                    <td v-if="index36 == 0" :rowspan="data.fourFuTangZhi.length">
                        <div class="cell">堂侄子</div>
                    </td>
                    <td>
                        <div class="cell">{{ item36.xm }}</div>
                    </td>
                    <td style="text-align:center">
                        <div class="cell">{{ item36.sgzt == 1 ? "已故":"在世"  }}</div>
                    </td>
                </tr>
                <tr class="el-table__row backColor4" v-for="(item37, index37) in data.fourFuTangZhiNv" :key="index37">
                    <td v-if="index37 == 0" :rowspan="data.fourFuTangZhiNv.length">
                        <div class="cell">四服</div>
                    </td>
                    <td v-if="index37 == 0" :rowspan="data.fourFuTangZhiNv.length">
                        <div class="cell">堂侄女</div>
                    </td>
                    <td>
                        <div class="cell">{{ item37.xm }}</div>
                    </td>
                    <td style="text-align:center">
                        <div class="cell">{{ item37.sgzt == 1 ? "已故":"在世"  }}</div>
                    </td>
                </tr>
                <tr class="el-table__row backColor4" v-for="(item38, index38) in data.fourFuTangXiongDi" :key="index38">
                    <td v-if="index38 == 0" :rowspan="data.fourFuTangXiongDi.length">
                        <div class="cell">四服</div>
                    </td>
                    <td v-if="index38 == 0" :rowspan="data.fourFuTangXiongDi.length">
                        <div class="cell">堂兄弟</div>
                    </td>
                    <td>
                        <div class="cell">{{ item38.xm }}</div>
                    </td>
                    <td style="text-align:center">
                        <div class="cell">{{ item38.sgzt == 1 ? "已故":"在世"  }}</div>
                    </td>
                </tr>
                <tr class="el-table__row backColor4" v-for="(item39, index39) in data.fourFuTangJieMei" :key="index39">
                    <td v-if="index39 == 0" :rowspan="data.fourFuTangJieMei.length">
                        <div class="cell">四服</div>
                    </td>
                    <td v-if="index39 == 0" :rowspan="data.fourFuTangJieMei.length">
                        <div class="cell">堂姐妹</div>
                    </td>
                    <td>
                        <div class="cell">{{ item39.xm }}</div>
                    </td>
                    <td style="text-align:center">
                        <div class="cell">{{ item39.sgzt == 1 ? "已故":"在世"  }}</div>
                    </td>
                </tr>
                <tr class="el-table__row backColor5" v-for="(item40, index40) in data.fiveFuCongXiongDi" :key="index40">
                    <td v-if="index40 == 0" :rowspan="data.fiveFuCongXiongDi.length">
                        <div class="cell">五服</div>
                    </td>
                    <td v-if="index40 == 0" :rowspan="data.fiveFuCongXiongDi.length">
                        <div class="cell">从兄弟</div>
                    </td>
                    <td>
                        <div class="cell">{{ item40.xm }}</div>
                    </td>
                    <td style="text-align:center">
                        <div class="cell">{{ item40.sgzt == 1 ? "已故":"在世"  }}</div>
                    </td>
                </tr>
                <tr class="el-table__row backColor5" v-for="(item41, index41) in data.fiveFuCongJieMei" :key="index41">
                    <td v-if="index41 == 0" :rowspan="data.fiveFuCongJieMei.length">
                        <div class="cell">五服</div>
                    </td>
                    <td v-if="index41 == 0" :rowspan="data.fiveFuCongJieMei.length">
                        <div class="cell">从姐妹</div>
                    </td>
                    <td>
                        <div class="cell">{{ item41.xm }}</div>
                    </td>
                    <td style="text-align:center">
                        <div class="cell">{{ item41.sgzt == 1 ? "已故":"在世"  }}</div>
                    </td>
                </tr>
                </tbody>
            </table>
        </el-tab-pane>
        <el-tab-pane label="九族五服图" name="map" class="mapdiv" style="width:100%">
            <!-- <el-button type="primary" size="small"  @click="convertToCanvas">测试生成canvas </el-button> -->
           <!--  <ul>
                <li>
                    <span class="four">
                        <b>四服</b>
                        <span v-for="(item, index) in data.fourFuGaoZuFuMu" :style="item.sex == 1 ? 'color:#c01a29' : ''" :key="index">{{
                            item.xm
                        }}</span>
                    </span>
                </li>
                <li>
                    <span class="four">
                        <b>四服</b>
                        <span v-for="(item, index) in data.fourFuShuBoZengZuFuMu" :style="item.sex == 1 ? 'color:#c01a29' : ''" :key="index">{{
                            item.xm
                        }}</span>
                    </span>
                    <span class="three">
                        <b>三服</b>
                        <span v-for="(item, index) in data.threeFuZengZuMu" :style="item.sex == 1 ? 'color:#c01a29' : ''" :key="index">{{
                            item.xm
                        }}</span>
                    </span>
                    <span class="four">
                        <b>四服</b>
                        <span v-for="(item, index) in data.fourFuZengZuGu" :style="item.sex == 1 ? 'color:#c01a29' : ''" :key="index">{{
                            item.xm
                        }}</span>
                    </span>
                </li>
                <li>
                    <span class="four">
                        <b>四服</b>
                        <span v-for="(item, index) in data.fourFuTangZuFuMu" :style="item.sex == 1 ? 'color:#c01a29' : ''" :key="index">{{
                            item.xm
                        }}</span>
                    </span>
                    <span class="three">
                        <b>三服</b>
                        <span v-for="(item, index) in data.threeFuShuBoZuFuMu" :style="item.sex == 1 ? 'color:#c01a29' : ''" :key="index">{{
                            item.xm
                        }}</span>
                    </span>
                    <span class="two">
                        <b>二服</b>
                        <span v-for="(item, index) in data.twoFuZuFuMu" :style="item.sex == 1 ? 'color:#c01a29' : ''" :key="index">{{
                            item.xm
                        }}</span>
                    </span>
                    <span class="three">
                        <b>三服</b>
                        <span v-for="(item, index) in data.threeFuZuGu" :style="item.sex == 1 ? 'color:#c01a29' : ''" :key="index">{{
                            item.xm
                        }}</span>
                    </span>
                    <span class="four">
                        <b>四服</b>
                        <span v-for="(item, index) in data.fourFuTangZuGu" :style="item.sex == 1 ? 'color:#c01a29' : ''" :key="index">{{
                            item.xm
                        }}</span>
                    </span>
                </li>

                <li>
                    <span class="four">
                        <b>四服</b>
                        <span v-for="(item, index) in data.fourFuTangBoFuMu" :style="item.sex == 1 ? 'color:#c01a29' : ''" :key="index">{{
                            item.xm
                        }}</span>
                    </span>
                    <span class="three">
                        <b>三服</b>
                        <span v-for="(item, index) in data.threeFuShuBoBoFuMu" :style="item.sex == 1 ? 'color:#c01a29' : ''" :key="index">{{
                            item.xm
                        }}</span>
                    </span>
                    <span class="two">
                        <b>二服</b>
                        <span v-for="(item, index) in data.twoFuShuBo" :style="item.sex == 1 ? 'color:#c01a29' : ''" :key="index">{{ item.xm }}</span>
                    </span>
                    <span class="one">
                        <b>一服</b>
                        <span v-for="(item, index) in data.oneFuFuMu" :style="item.sex == 1 ? 'color:#c01a29' : ''" :key="index">{{ item.xm }}</span>
                    </span>
                    <span class="two">
                        <b>二服</b>
                        <span v-for="(item, index) in data.twoFuGuGu" :style="item.sex == 1 ? 'color:#c01a29' : ''" :key="index">{{ item.xm }}</span>
                    </span>
                    <span class="three">
                        <b>三服</b>
                        <span v-for="(item, index) in data.threeFuShuBoGu" :style="item.sex == 1 ? 'color:#c01a29' : ''" :key="index">{{
                            item.xm
                        }}</span>
                    </span>
                    <span class="four">
                        <b>四服</b>
                        <span v-for="(item, index) in data.fourFuTangGu" :style="item.sex == 1 ? 'color:#c01a29' : ''" :key="index">{{
                            item.xm
                        }}</span>
                    </span>
                </li>
                <li>
                    <span class="five">
                        <b>五服</b>
                        <span v-for="(item, index) in data.fiveFuCongXiongDi" :style="item.sex == 1 ? 'color:#c01a29' : ''" :key="index">{{
                            item.xm
                        }}</span>
                    </span>
                    <span class="four">
                        <b>四服</b>
                        <span v-for="(item, index) in data.fourFuTangXiongDi" :style="item.sex == 1 ? 'color:#c01a29' : ''" :key="index">{{
                            item.xm
                        }}</span>
                    </span>
                    <span class="three">
                        <b>三服</b>
                        <span v-for="(item, index) in data.threeFuShuBoXiongDi" :style="item.sex == 1 ? 'color:#c01a29' : ''" :key="index">{{
                            item.xm
                        }}</span>
                    </span>
                    <span class="two">
                        <b>二服</b>
                        <span v-for="(item, index) in data.twoFuXiongDi" :style="item.sex == 1 ? 'color:#c01a29' : ''" :key="index">{{
                            item.xm
                        }}</span>
                    </span>
                    <span class="one">
                        <b>一服</b>
                        <span v-for="(item, index) in data.oneFuZiJi" :style="item.sex == 1 ? 'color:#c01a29' : ''" :key="index">{{
                            item.xm
                        }}</span></span
                    >
                    <span class="two">
                        <b>二服</b>
                        <span v-for="(item, index) in data.twoFuJieMei" :style="item.sex == 1 ? 'color:#c01a29' : ''" :key="index">{{
                            item.xm
                        }}</span>
                    </span>
                    <span class="three">
                        <b>三服</b>
                        <span v-for="(item, index) in data.threeFuShuBoJieMei" :style="item.sex == 1 ? 'color:#c01a29' : ''" :key="index">{{
                            item.xm
                        }}</span>
                    </span>
                    <span class="four">
                        <b>四服</b>
                        <span v-for="(item, index) in data.fourFuTangJieMei" :style="item.sex == 1 ? 'color:#c01a29' : ''" :key="index">{{
                            item.xm
                        }}</span>
                    </span>
                    <span class="five">
                        <b>五服</b>
                        <span v-for="(item, index) in data.fiveFuCongJieMei" :style="item.sex == 1 ? 'color:#c01a29' : ''" :key="index">{{
                            item.xm
                        }}</span>
                    </span>
                </li>

                <li>
                    <span class="four">
                        <b>四服</b>
                        <span v-for="(item, index) in data.fourFuTangZhi" :style="item.sex == 1 ? 'color:#c01a29' : ''" :key="index">{{
                            item.xm
                        }}</span>
                    </span>
                    <span class="three">
                        <b>三服</b>
                        <span v-for="(item, index) in data.threeFuShuBoZhiZi" :style="item.sex == 1 ? 'color:#c01a29' : ''" :key="index">{{
                            item.xm
                        }}</span>
                    </span>
                    <span class="two">
                        <b>二服</b>
                        <span v-for="(item, index) in data.twoFuZhiZi" :style="item.sex == 1 ? 'color:#c01a29' : ''" :key="index">{{ item.xm }}</span>
                    </span>
                    <span class="one">
                        <b>一服</b>
                        <span v-for="(item, index) in data.oneFuZiNv" :style="item.sex == 1 ? 'color:#c01a29' : ''" :key="index">{{ item.xm }}</span>
                    </span>
                    <span class="two">
                        <b>二服</b>
                        <span v-for="(item, index) in data.twoFuZhiNv" :style="item.sex == 1 ? 'color:#c01a29' : ''" :key="index">{{ item.xm }}</span>
                    </span>
                    <span class="three">
                        <b>三服</b>
                        <span v-for="(item, index) in data.threeFuShuBoZhiNv" :style="item.sex == 1 ? 'color:#c01a29' : ''" :key="index">{{
                            item.xm
                        }}</span>
                    </span>
                    <span class="four">
                        <b>四服</b>
                        <span v-for="(item, index) in data.fourFuTangZhiNv" :style="item.sex == 1 ? 'color:#c01a29' : ''" :key="index">{{
                            item.xm
                        }}</span>
                    </span>
                </li>

                <li>
                    <span class="four">
                        <b>四服</b>
                        <span v-for="(item, index) in data.fourFuTangSunZi" :style="item.sex == 1 ? 'color:#c01a29' : ''" :key="index">{{
                            item.xm
                        }}</span>
                    </span>
                    <span class="three">
                        <b>三服</b>
                        <span v-for="(item, index) in data.threeFuShuBoSun" :style="item.sex == 1 ? 'color:#c01a29' : ''" :key="index">{{
                            item.xm
                        }}</span>
                    </span>
                    <span class="two">
                        <b>二服</b>
                        <span v-for="(item, index) in data.twoFuSunZiNv" :style="item.sex == 1 ? 'color:#c01a29' : ''" :key="index">{{
                            item.xm
                        }}</span>
                    </span>
                    <span class="three">
                        <b>三服</b>
                        <span v-for="(item, index) in data.threeFuShuBoSunNv" :style="item.sex == 1 ? 'color:#c01a29' : ''" :key="index">{{
                            item.xm
                        }}</span>
                    </span>
                    <span class="four">
                        <b>四服</b>
                        <span v-for="(item, index) in data.fourFuTangSunNv" :style="item.sex == 1 ? 'color:#c01a29' : ''" :key="index">{{
                            item.xm
                        }}</span>
                    </span>
                </li>

                <li>
                    <span class="four">
                        <b>四服</b>
                        <span v-for="(item, index) in data.fourFuShuBoZengSun" :style="item.sex == 1 ? 'color:#c01a29' : ''" :key="index">{{
                            item.xm
                        }}</span>
                    </span>
                    <span class="three">
                        <b>三服</b>
                        <span v-for="(item, index) in data.threeFuZengSunNv" :style="item.sex == 1 ? 'color:#c01a29' : ''" :key="index">{{
                            item.xm
                        }}</span>
                    </span>
                    <span class="four">
                        <b>四服</b>
                        <span v-for="(item, index) in data.fourFuBoShuZengSunNv" :style="item.sex == 1 ? 'color:#c01a29' : ''" :key="index">{{
                            item.xm
                        }}</span>
                    </span>
                </li>
                <li>
                    <span class="four">
                        <b>四服</b>
                        <span v-for="(item, index) in data.fourFuXuanSunNv" :style="item.sex == 1 ? 'color:#c01a29' : ''" :key="index">{{
                            item.xm
                        }}</span>
                    </span>
                </li>
            </ul> -->
           <!-- @swipeleft="nowLeft()" @swiperight="nowRight()" -->
        <v-touch @pinchstart="handlePinchStart" @pinchend="handlePinchEnd" 
        @pinch="handlePinch" @touchstart="touchstart"
          @touchmove="touchMove" @touchend="touchEnd" class="zoomable-area" >
            <ul ref="fivefuUl" class="fivefuUl" style="width:920px;">
                <li>
                    <span class="four">
                        <div><b>四服</b></div>
                        <span :class="data.fourFuGaoZuFuMu.length == 1 ?'oneway':(data.fourFuGaoZuFuMu.length > 6 ? 'spanmore':'')" v-for="(item, index) in data.fourFuGaoZuFuMu" :style="item.sex == 1 ? 'color:#c01a29' : ''" :key="index">{{
                            item.xm
                        }}</span>
                    </span>
                </li>
                <li>
                    <span class="four">
                        <div><b>四服</b></div>
                        <span :class="data.fourFuShuBoZengZuFuMu.length == 1 ?'oneway':(data.fourFuShuBoZengZuFuMu.length > 6 ? 'spanmore':'')"  v-for="(item, index) in data.fourFuShuBoZengZuFuMu" :style="item.sex == 1 ? 'color:#c01a29' : ''" :key="index">{{
                            item.xm
                        }}</span>
                    </span>
                    <span class="three">
                        <div><b>三服</b></div>
                        <span :class="data.threeFuZengZuMu.length == 1 ?'oneway':(data.threeFuZengZuMu.length > 6 ? 'spanmore':'')" v-for="(item, index) in data.threeFuZengZuMu" :style="item.sex == 1 ? 'color:#c01a29' : ''" :key="index">{{
                            item.xm
                        }}</span>
                    </span>
                    <span class="four">
                        <div><b>四服</b></div>
                        <span :class="data.fourFuZengZuGu.length == 1 ?'oneway':(data.fourFuZengZuGu.length > 6 ? 'spanmore':'')" v-for="(item, index) in data.fourFuZengZuGu" :style="item.sex == 1 ? 'color:#c01a29' : ''" :key="index">{{
                            item.xm
                        }}</span>
                    </span>
                </li>
                <li>
                    <span class="four">
                        <div><b>四服</b></div>
                        <span :class="data.fourFuTangZuFuMu.length == 1 ?'oneway':(data.fourFuTangZuFuMu.length > 6 ? 'spanmore':'')" v-for="(item, index) in data.fourFuTangZuFuMu" :style="item.sex == 1 ? 'color:#c01a29' : ''" :key="index">{{
                            item.xm
                        }}</span>
                    </span>
                    <span class="three">
                        <div><b>三服</b></div>
                        <span :class="data.threeFuShuBoZuFuMu.length == 1 ?'oneway':(data.threeFuShuBoZuFuMu.length > 6 ? 'spanmore':'')" v-for="(item, index) in data.threeFuShuBoZuFuMu" :style="item.sex == 1 ? 'color:#c01a29' : ''" :key="index">{{
                            item.xm
                        }}</span>
                    </span>
                    <span class="two">
                        <div><b>二服</b></div>
                        <span :class="data.twoFuZuFuMu.length == 1 ?'oneway':(data.twoFuZuFuMu.length > 6 ? 'spanmore':'')" v-for="(item, index) in data.twoFuZuFuMu" :style="item.sex == 1 ? 'color:#c01a29' : ''" :key="index">{{
                            item.xm
                        }}</span>
                    </span>
                    <span class="three">
                        <div><b>三服</b></div>
                        <span :class="data.threeFuZuGu.length == 1 ?'oneway':(data.threeFuZuGu.length > 6 ? 'spanmore':'')" v-for="(item, index) in data.threeFuZuGu" :style="item.sex == 1 ? 'color:#c01a29' : ''" :key="index">{{
                            item.xm
                        }}</span>
                    </span>
                    <span class="four">
                        <div><b>四服</b></div>
                        <span :class="data.fourFuTangZuGu.length == 1 ?'oneway':(data.fourFuTangZuGu.length > 6 ? 'spanmore':'')" v-for="(item, index) in data.fourFuTangZuGu" :style="item.sex == 1 ? 'color:#c01a29' : ''" :key="index">{{
                            item.xm
                        }}</span>
                    </span>
                </li>

                <li>
                    <span class="four">
                        <div><b>四服</b></div>
                        <span :class="data.fourFuTangBoFuMu.length == 1 ?'oneway':(data.fourFuTangBoFuMu.length > 6 ? 'spanmore':'')" v-for="(item, index) in data.fourFuTangBoFuMu" :style="item.sex == 1 ? 'color:#c01a29' : ''" :key="index">{{
                            item.xm
                        }}</span>
                    </span>
                    <span class="three">
                        <div><b>三服</b></div>
                        <span :class="data.threeFuShuBoBoFuMu.length == 1 ?'oneway':(data.threeFuShuBoBoFuMu.length > 6 ? 'spanmore':'')" v-for="(item, index) in data.threeFuShuBoBoFuMu" :style="item.sex == 1 ? 'color:#c01a29' : ''" :key="index">{{
                            item.xm
                        }}</span>
                    </span>
                    <span class="two">
                        <div><b>二服</b></div>
                        <span :class="data.twoFuShuBo.length == 1 ?'oneway':(data.twoFuShuBo.length > 6 ? 'spanmore':'')" v-for="(item, index) in data.twoFuShuBo" :style="item.sex == 1 ? 'color:#c01a29' : ''" :key="index">{{ item.xm }}</span>
                    </span>
                    <span class="one">
                        <div><b>一服</b></div>
                        <span :class="data.oneFuFuMu.length == 1 ?'oneway':(data.oneFuFuMu.length > 6 ? 'spanmore':'')" v-for="(item, index) in data.oneFuFuMu" :style="item.sex == 1 ? 'color:#c01a29' : ''" :key="index">{{ item.xm }}</span>
                    </span>
                    <span class="two">
                        <div><b>二服</b></div>
                        <span :class="data.twoFuGuGu.length == 1 ?'oneway':(data.twoFuGuGu.length > 6 ? 'spanmore':'')" v-for="(item, index) in data.twoFuGuGu" :style="item.sex == 1 ? 'color:#c01a29' : ''" :key="index">{{ item.xm }}</span>
                    </span>
                    <span class="three">
                        <div><b>三服</b></div>
                        <span :class="data.threeFuShuBoGu.length == 1 ?'oneway':(data.threeFuShuBoGu.length > 6 ? 'spanmore':'')" v-for="(item, index) in data.threeFuShuBoGu" :style="item.sex == 1 ? 'color:#c01a29' : ''" :key="index">{{
                            item.xm
                        }}</span>
                    </span>
                    <span class="four">
                        <div><b>四服</b></div>
                        <span :class="data.fourFuTangGu.length == 1 ?'oneway':(data.fourFuTangGu.length > 6 ? 'spanmore':'')" v-for="(item, index) in data.fourFuTangGu" :style="item.sex == 1 ? 'color:#c01a29' : ''" :key="index">{{
                            item.xm
                        }}</span>
                    </span>
                </li>
                <li>
                    <span class="five">
                        <div><b>五服</b></div>
                        <span :class="data.fiveFuCongXiongDi.length == 1 ?'oneway':(data.fiveFuCongXiongDi.length > 6 ? 'spanmore':'')" v-for="(item, index) in data.fiveFuCongXiongDi" :style="item.sex == 1 ? 'color:#c01a29' : ''" :key="index">{{
                            item.xm
                        }}</span>
                    </span>
                    <span class="four">
                        <div><b>四服</b></div>
                        <span :class="data.fourFuTangXiongDi.length == 1 ?'oneway':(data.fourFuTangXiongDi.length > 6 ? 'spanmore':'')" v-for="(item, index) in data.fourFuTangXiongDi" :style="item.sex == 1 ? 'color:#c01a29' : ''" :key="index">{{
                            item.xm
                        }}</span>
                    </span>
                    <span class="three">
                        <div><b>三服</b></div>
                        <span :class="data.threeFuShuBoXiongDi.length == 1 ?'oneway':(data.threeFuShuBoXiongDi.length > 6 ? 'spanmore':'')" v-for="(item, index) in data.threeFuShuBoXiongDi" :style="item.sex == 1 ? 'color:#c01a29' : ''" :key="index">{{
                            item.xm
                        }}</span>
                    </span>
                    <span class="two">
                        <div><b>二服</b></div>
                        <span :class="data.twoFuXiongDi.length == 1 ?'oneway':(data.twoFuXiongDi.length > 6 ? 'spanmore':'')" v-for="(item, index) in data.twoFuXiongDi" :style="item.sex == 1 ? 'color:#c01a29' : ''" :key="index">{{
                            item.xm
                        }}</span>
                    </span>
                    <span class="one">
                        <div><b>一服</b></div>
                        <span :class="data.oneFuZiJi.length == 1 ?'oneway':(data.oneFuZiJi.length > 6 ? 'spanmore':'')" v-for="(item, index) in data.oneFuZiJi" :style="item.sex == 1 ? 'color:#c01a29' : ''" :key="index">{{
                            item.xm
                        }}</span></span
                    >
                    <span class="two">
                        <div><b>二服</b></div>
                        <span :class="data.twoFuJieMei.length == 1 ?'oneway':(data.twoFuJieMei.length > 6 ? 'spanmore':'')" v-for="(item, index) in data.twoFuJieMei" :style="item.sex == 1 ? 'color:#c01a29' : ''" :key="index">{{
                            item.xm
                        }}</span>
                    </span>
                    <span class="three">
                        <div><b>三服</b></div>
                        <span :class="data.threeFuShuBoJieMei.length == 1 ?'oneway':(data.threeFuShuBoJieMei.length > 6 ? 'spanmore':'')" v-for="(item, index) in data.threeFuShuBoJieMei" :style="item.sex == 1 ? 'color:#c01a29' : ''" :key="index">{{
                            item.xm
                        }}</span>
                    </span>
                    <span class="four">
                        <div><b>四服</b></div>
                        <span :class="data.fourFuTangJieMei.length == 1 ?'oneway':(data.fourFuTangJieMei.length > 6 ? 'spanmore':'')" v-for="(item, index) in data.fourFuTangJieMei" :style="item.sex == 1 ? 'color:#c01a29' : ''" :key="index">{{
                            item.xm
                        }}</span>
                    </span>
                    <span class="five">
                        <div><b>五服</b></div>
                        <span :class="data.fiveFuCongJieMei.length == 1 ?'oneway':(data.fiveFuCongJieMei.length > 6 ? 'spanmore':'')" v-for="(item, index) in data.fiveFuCongJieMei" :style="item.sex == 1 ? 'color:#c01a29' : ''" :key="index">{{
                            item.xm
                        }}</span>
                    </span>
                </li>

                <li>
                    <span class="four">
                        <div><b>四服</b></div>
                        <span :class="data.fourFuTangZhi.length == 1 ?'oneway':(data.fourFuTangZhi.length > 6 ? 'spanmore':'')" v-for="(item, index) in data.fourFuTangZhi" :style="item.sex == 1 ? 'color:#c01a29' : ''" :key="index">{{
                            item.xm
                        }}</span>
                    </span>
                    <span class="three">
                        <div><b>三服</b></div>
                        <span :class="data.threeFuShuBoZhiZi.length == 1 ?'oneway':(data.threeFuShuBoZhiZi.length > 6 ? 'spanmore':'')" v-for="(item, index) in data.threeFuShuBoZhiZi" :style="item.sex == 1 ? 'color:#c01a29' : ''" :key="index">{{
                            item.xm
                        }}</span>
                    </span>
                    <span class="two">
                        <div><b>二服</b></div>
                        <span :class="data.twoFuZhiZi.length == 1 ?'oneway':(data.twoFuZhiZi.length > 6 ? 'spanmore':'')" v-for="(item, index) in data.twoFuZhiZi" :style="item.sex == 1 ? 'color:#c01a29' : ''" :key="index">{{ item.xm }}</span>
                    </span>
                    <span class="one">
                        <div><b>一服</b></div>
                        <span :class="data.oneFuZiNv.length == 1 ?'oneway':(data.oneFuZiNv.length > 6 ? 'spanmore':'')" v-for="(item, index) in data.oneFuZiNv" :style="item.sex == 1 ? 'color:#c01a29' : ''" :key="index">{{ item.xm }}</span>
                    </span>
                    <span class="two">
                        <div><b>二服</b></div>
                        <span :class="data.twoFuZhiNv.length == 1 ?'oneway':(data.twoFuZhiNv.length > 6 ? 'spanmore':'')" v-for="(item, index) in data.twoFuZhiNv" :style="item.sex == 1 ? 'color:#c01a29' : ''" :key="index">{{ item.xm }}</span>
                    </span>
                    <span class="three">
                        <div><b>三服</b></div>
                        <span :class="data.threeFuShuBoZhiNv.length == 1 ?'oneway':(data.threeFuShuBoZhiNv.length > 6 ? 'spanmore':'')" v-for="(item, index) in data.threeFuShuBoZhiNv" :style="item.sex == 1 ? 'color:#c01a29' : ''" :key="index">{{
                            item.xm
                        }}</span>
                    </span>
                    <span class="four">
                        <div><b>四服</b></div>
                        <span :class="data.fourFuTangZhiNv.length == 1 ?'oneway':(data.fourFuTangZhiNv.length > 6 ? 'spanmore':'')" v-for="(item, index) in data.fourFuTangZhiNv" :style="item.sex == 1 ? 'color:#c01a29' : ''" :key="index">{{
                            item.xm
                        }}</span>
                    </span>
                </li>

                <li>
                    <span class="four">
                        <div><b>四服</b></div>
                        <span :class="data.fourFuTangSunZi.length == 1 ?'oneway':(data.fourFuTangSunZi.length > 6 ? 'spanmore':'')" v-for="(item, index) in data.fourFuTangSunZi" :style="item.sex == 1 ? 'color:#c01a29' : ''" :key="index">{{
                            item.xm
                        }}</span>
                    </span>
                    <span class="three">
                        <div><b>三服</b></div>
                        <span :class="data.threeFuShuBoSun.length == 1 ?'oneway':(data.threeFuShuBoSun.length > 6 ? 'spanmore':'')" v-for="(item, index) in data.threeFuShuBoSun" :style="item.sex == 1 ? 'color:#c01a29' : ''" :key="index">{{
                            item.xm
                        }}</span>
                    </span>
                    <span class="two">
                        <div><b>二服</b></div>
                        <span :class="data.twoFuSunZiNv.length == 1 ?'oneway':(data.twoFuSunZiNv.length > 6 ? 'spanmore':'')" v-for="(item, index) in data.twoFuSunZiNv" :style="item.sex == 1 ? 'color:#c01a29' : ''" :key="index">{{
                            item.xm
                        }}</span>
                    </span>
                    <span class="three">
                        <div><b>三服</b></div>
                        <span :class="data.threeFuShuBoSunNv.length == 1 ?'oneway':(data.threeFuShuBoSunNv.length > 6 ? 'spanmore':'')" v-for="(item, index) in data.threeFuShuBoSunNv" :style="item.sex == 1 ? 'color:#c01a29' : ''" :key="index">{{
                            item.xm
                        }}</span>
                    </span>
                    <span class="four">
                        <div><b>四服</b></div>
                        <span :class="data.fourFuTangSunNv.length == 1 ?'oneway':(data.fourFuTangSunNv.length > 6 ? 'spanmore':'')" v-for="(item, index) in data.fourFuTangSunNv" :style="item.sex == 1 ? 'color:#c01a29' : ''" :key="index">{{
                            item.xm
                        }}</span>
                    </span>
                </li>

                <li>
                    <span class="four">
                        <div><b>四服</b></div>
                        <span :class="data.fourFuShuBoZengSun.length == 1 ?'oneway':(data.fourFuShuBoZengSun.length > 6 ? 'spanmore':'')" v-for="(item, index) in data.fourFuShuBoZengSun" :style="item.sex == 1 ? 'color:#c01a29' : ''" :key="index">{{
                            item.xm
                        }}</span>
                    </span>
                    <span class="three">
                        <div><b>三服</b></div>
                        <span :class="data.threeFuZengSunNv.length == 1 ?'oneway':(data.threeFuZengSunNv.length > 6 ? 'spanmore':'')" v-for="(item, index) in data.threeFuZengSunNv" :style="item.sex == 1 ? 'color:#c01a29' : ''" :key="index">{{
                            item.xm
                        }}</span>
                    </span>
                    <span class="four">
                        <div><b>四服</b></div>
                        <span :class="data.fourFuBoShuZengSunNv.length == 1 ?'oneway':(data.fourFuBoShuZengSunNv.length > 6 ? 'spanmore':'')" v-for="(item, index) in data.fourFuBoShuZengSunNv" :style="item.sex == 1 ? 'color:#c01a29' : ''" :key="index">{{
                            item.xm
                        }}</span>
                    </span>
                </li>
                <li>
                    <span class="four">
                        <div><b>四服</b></div>
                        <span :class="data.fourFuXuanSunNv  .length == 1 ?'oneway':(data.fourFuXuanSunNv.length > 6 ? 'spanmore':'')" v-for="(item, index) in data.fourFuXuanSunNv" :style="item.sex == 1 ? 'color:#c01a29' : ''" :key="index">{{
                            item.xm
                        }}</span>
                    </span>
                </li>
            </ul>
        </v-touch>
            <!-- <canvas ref="canvas"></canvas> -->
        </el-tab-pane>
        <!-- <el-tab-pane label="角色管理" name="third">角色管理</el-tab-pane>
        <el-tab-pane label="定时任务补偿" name="fourth">定时任务补偿</el-tab-pane> -->
     </el-tabs>
    </div>
</template>
<script>
import api from "@/request/api";
import Head from "@/components/header.vue";
import html2canvas from 'html2canvas';

export default {
    data() {
        return {
            activeName: 'table',
            tableData: [],
            data: {},
            name: "孙洪津",
            fathername: "孙献文",
            timeOutEvent: 0,
            oldNodePos: {
                x: 0,
                y: 0,
            },
            oldMousePos: {
                x: 0,
                y: 0
            },
            oldIndex: 0,
            // 长按标识
            longClick: 0
        };
    },
    mounted() {
        // api.memberFivefu(this.$qs.stringify({ fid: localStorage.getItem("fid"), mid: sessionStorage.getItem("memberId") })).then((res) => {
        //     if (res.code == 0) {
        //         this.data = res.data;
        //         var data = [];
        //         for (const key in res.data) {
        //             if (res.data[key].length != 0) {
        //                 res.data[key][0].relation = key;
        //                 data.push(res.data[key][0]);
        //             }
        //         }
        //         this.tableData = data;
        //     }
        // });
    },
    methods: {
        search() {
            // /api/member/fivefubyname
            api.memberFivefubyname(
                this.$qs.stringify({
                    fid: localStorage.getItem("fid"),
                    name: this.name,
                    fathername: this.fathername
                })
            ).then((res) => {
                if (res.code == 0) {
                    this.data = res.data;
                    this.tableData = res.data;
                    console.log(this.data,'----data')
                    console.log(this.tableData,'----tableData')
                }
            });
        },
        handleClick(tab, event) {
            console.log(tab.name,'---table');
            if(tab.name=='map'){
                const pageWidth = window.innerWidth;
                console.log( pageWidth,'---- pageWidth')
            }
        },
        handlePinchStart(event) {
            // 当用户开始缩放时的处理逻辑
        },
        handlePinchEnd(event) {
            // 当用户结束缩放时的处理逻辑
        },
        handlePinch(event) {
            const zoomFactor = event.scale; // 缩放因子
            const image = this.$refs.fivefuUl;
            console.log(zoomFactor,'----zoomFactor');
            if (image) {
                // 根据缩放因子调整图片大小或者应用缩放样式
                image.style.transform = `scale(${zoomFactor})`;
            }
        },
        touchstart(ev, item) {
            this.longClick = 0;
            const that = this;
            const selectDom =this.$refs.fivefuUl; // div元素
            this.timeOutEvent = setTimeout(() => {
                that.longClick = 1;
                that.selectItem = item;
                // 元素初始位置
                that.oldNodePos = {
                x: selectDom.offsetLeft,
                y: selectDom.offsetTop
                };
                // 鼠标原始位置
                that.oldMousePos = {
                x: ev.touches[0].pageX,
                y: ev.touches[0].pageY
                };
                const lefts = that.oldMousePos.x - that.oldNodePos.x; // x轴偏移量
                const tops = that.oldMousePos.y - that.oldNodePos.y; // y轴偏移量
                const { pageX, pageY } = ev.touches[0]; // 手指位置
                that.$refs.fivefuUl.style.left = `${pageX - lefts}px`;
                that.$refs.fivefuUl.style.top = `${pageY - tops}px`;
            }, 500);
        },
        touchMove(ev) {
            clearTimeout(this.timeOutEvent);
            const selectDom =this.$refs.fivefuUl; // li元素
            if (this.longClick === 1) {
                const lefts = this.oldMousePos.x - this.oldNodePos.x; // x轴偏移量
                const tops = this.oldMousePos.y - this.oldNodePos.y; // y轴偏移量
                const { pageX, pageY } = ev.touches[0]; // 手指位置
                this.$refs.fivefuUl.style.left = `${pageX - lefts}px`;
                this.$refs.fivefuUl.style.top = `${pageY - tops}px`;
                // this.cardIndex(selectDom, pageX, pageY);
            }
        },
        touchEnd() {
            // alert(111)
            clearTimeout(this.timeOutEvent);
            // this.selectItem = {};
        },
        nowLeft() {//左滑
            // 获取list
            let now = document.getElementsByClassName("list")[0];
            now.style.transform += "translateX(-30rem)";
            now.style.transition = "all ease 0.5s";
        },
        nowRight() {//右滑
            // 获取list
            let now = document.getElementsByClassName("list")[0];
            now.style.transform += "translateX(30rem)";
            now.style.transition = "all ease 0.5s";
        },
        
        async convertToCanvas() {
            try {
                const canvas = this.$refs.canvas;
                const list = this.$refs.list;
                //   console.log(list,'----list')
                const canvasImage = await html2canvas(list);
                canvas.height = canvasImage.height/2;
                canvas.width = canvasImage.width/2;
                canvas.scale = 0.5;
                console.log( canvas,'---- canvas')
                
                const ctx = canvas.getContext('2d');
                ctx.drawImage(canvasImage, 0, 0);
            } catch (error) {
                console.error('Error converting to canvas:', error);
            }
      },
    },
    components: {
        Head
    }
};
</script>
<style lang="less">

.fivefu {
    width: 100%;
    height: 100%;
    .chartTop {
        height: 55px;
        line-height: 55px;
        padding-right: 20px;
        padding-left:10px;
        .el-input {
            display: inline-block;
            width: 100px;
        }
    }
    .flSearch{
        width: 100%;
        font-size: 14px;
        padding:10px;
        div{
            margin-bottom:10px;
        }
        .el-input {
            // margin: 10px 0;
            width:80px;
            font-size: 1rem;
            /deep/.el-input__inner{
                padding: 0 10px !important;
            }
        }
    }
   
    > .search {
        // width: 200px;
        padding: 10px 20px;
        .el-input {
            margin: 10px 0;
        }
    }
    .tab {
        .active {
            color: #ff0000;
        }
        button {
            color: #000;
            margin: 0 5px;
        }
    }
    .fiveTable{
        overflow: auto;
        font-size:13px;
        .el-table__cell.is-center{
            text-align: left !important;
        }
        .backColor1 {
            background-color: #fefc0b !important;
        }
        .backColor1,.backColor2,.backColor3,.backColor4,.backColor5{
            .cell{
                text-align: left;
                padding-left:4px !important;
            }
        }
        .backColor2 {
            background-color: #b3dee7 !important;
        }
        .backColor3 {
            background-color: #fabe8c !important;
        }
        .backColor4 {
            background-color: #91d04e !important;
        }
        .backColor5 {
            background-color: #fbc201 !important;
        }
        /deep/.el-table {
        border: 1px solid #000000 !important;
        }
        /deep/.el-table--border th.el-table__cell,
        /deep/.el-table__fixed-right-patch,
        /deep/td.el-table__cell,
        /deep/th.el-table__cell.is-leaf {
            border-bottom: 1px solid #000000 !important;
        }
        /deep/.el-table--border .el-table__cell {
            border-right: 1px solid #000 !important;
        }
        /deep/.el-table--border,
        /deep/.el-table--group {
            border: 1px solid #000000 !important;
        }

        tr td, tr th {
            border: 1px solid #908e8e;
            vertical-align:middle;
            padding: 5px;
        }
    }
    /* > .main-right {
        width: calc(100% - 240px);
        height: calc(100% - 115px);
    }

    .mapdivApp {
        // height: calc(100% - 115px);
        width:100% !important;
    
        overflow: auto;
        ul {
            text-align: center;
            width: 750px;
            margin: 20px auto;
            .one,
            .two,
            .three,
            .four,
            .five {
                display: inline-block;
                height: 55px;
                width: 80px;
                margin: -1px;
                color: #000;
                overflow-x: auto;
            }
            .one {
                background: #fefc0b;
            }
            .two {
                background: #b3dee7;
            }
            .three {
                background: #fabe8c;
            }
            .four {
                background: #91d04e;
            }
            .five {
                background: #fbc201;
            }
            .one span,
            .two span,
            .three span,
            .four span,
            .five span {
                width:40px;
                display: block;
                float:left;
            }
        }
    } */
    .mapdiv {
        // .zoomable-area {
        //     // overflow: hidden; /* 确保缩放后的图片不会超出容器 */
        //     // transform: scale(0.4);
        //     // transform-origin: top left;
        // }
        // height: calc(100% - 115px);
        // width:100% !important; 
        // width: calc(100% - 200px);

        overflow: auto;
        ul.fivefuUl {
            text-align: center;
            width: 750px;
            margin: 40px auto;
            transform: scale(0.4);
            transform-origin: top left;
            .one,
            .two,
            .three,
            .four,
            .five {
                display: inline-block;
                height: 80px;
                width: 100px;
                margin: -1px;
                color: #000;
                overflow-x: auto;
            }
            .one {
                background: #fefc0b;
            }
            .two {
                background: #b3dee7;
            }
            .three {
                background: #fabe8c;
            }
            .four {
                background: #91d04e;
            }
            .five {
                background: #fbc201;
            }
            .one b,
            .two b,
            .three b,
            .four b,
            .five b {
                font-size:14px;
            }
            .one span,
            .two span,
            .three span,
            .four span,
            .five span {
                width:50px;
                display: block;
                float:left;
            }
          .one .spanmore,
          .two .spanmore,
          .three .spanmore,
          .four .spanmore,
          .five .spanmore {
            width:40px;
            display: block;
            float:left;
          }


            .one .oneway,
            .two .oneway,
            .three .oneway,
            .four .oneway,
            .five .oneway {
                width:100px;
                display: block;
            }
        }
    }

}
</style>



// WEBPACK FOOTER //
// src/views/mobile/fivefu.vue